import {ActionTree} from "vuex";
import {ProcessProfileState, ProcessProfile} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<ProcessProfileState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/process_profiles', {params: params})
        .then((response: AxiosResponse) => {
          const processProfiles: ProcessProfile[] = response.data;
          commit('setProcessProfiles', processProfiles);
          return processProfiles;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/process_profiles', params)
        .then((response: AxiosResponse) => {
          const processProfile: ProcessProfile = response.data;
          commit('addProcessProfile', processProfile);
          return processProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/process_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const processProfile: ProcessProfile = response.data;
          commit('updateProcessProfile', processProfile);
          return processProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/process_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteProcessProfile', id);
        });
  }
}

export default actions;
